const CONCURRENCY = 6;
const STARTS_PER_SEC = 10;
const ROOT_MARGIN = 150;
const MAX_RETRIES = 5;
const BASE_BACKOFF = 600;

const queue = [];
let active = 0;

let tokens = STARTS_PER_SEC;
setInterval(() => {
    tokens = STARTS_PER_SEC;
}, 700);

let io;

const vpCenter = () => (window.innerHeight || document.documentElement.clientHeight) / 2;

function priorityFor(el) {
    const r = el.getBoundingClientRect();
    const center = r.top + r.height / 2;
    return Math.abs(center - vpCenter());
}

function pushWithPriority(img, wrapper) {
    if (img.dataset.loaded === '1' || img.dataset.queued === '1') return;

    img.dataset.queued = '1';

    queue.push({ img, wrapper, priority: priorityFor(wrapper) });
    queue.sort((a, b) => a.priority - b.priority);

    pump();
}

function startImage(img, wrapper) {
    return new Promise(resolve => {
        const url = img.getAttribute('data-src');
        if (!url) return resolve();

        const loader = wrapper.querySelector('.flickering-loading-block');
        const retry = parseInt(img.dataset.retry || '0', 10);

        img.onload = () => {
            img.dataset.loaded = '1';
            img.classList.remove('opacity-0', 'pointer-events-none');

            if (loader) loader.classList.add('hidden');

            io.unobserve(wrapper);
            resolve();
        };

        img.onerror = () => {
            if (retry < MAX_RETRIES) {
                const delay = Math.round(BASE_BACKOFF * Math.pow(2, retry) * (0.7 + Math.random() * 0.6));
                img.dataset.retry = String(retry + 1);
                img.removeAttribute('src'); // сброс неудачной попытки
                img.dataset.queued = '0';
                setTimeout(() => pushWithPriority(img, wrapper), delay);
            }

            resolve();
        };

        img.src = url;
    });
}

function pump() {
    while (active < CONCURRENCY && tokens > 0 && queue.length) {
        const { img, wrapper } = queue.shift();
        tokens--;
        active++;
        startImage(img, wrapper).finally(() => {
            active--;
            img.dataset.queued = '0';
            setTimeout(pump, 0);
        });
    }
}

function observeWrapper(wrapper) {
    if (!wrapper || wrapper.dataset.observed === '1') return;
    wrapper.dataset.observed = '1';
    io.observe(wrapper);
}

function scan() {
    document.querySelectorAll('.avatar-holder').forEach(observeWrapper);
}

function init() {
    io = new IntersectionObserver(
        entries => {
            entries.forEach(entry => {
                const wrapper = entry.target;
                if (!entry.isIntersecting) return;
                const img = wrapper.querySelector('img.lazy-img[data-src]');
                if (img) pushWithPriority(img, wrapper);
            });
        },
        { root: null, rootMargin: `${ROOT_MARGIN}px 0px`, threshold: 0 }
    );

    scan();

    let raf = null;
    window.addEventListener(
        'scroll',
        () => {
            if (raf) return;

            raf = requestAnimationFrame(() => {
                raf = null;
                for (const item of queue) item.priority = priorityFor(item.wrapper);
                queue.sort((a, b) => a.priority - b.priority);
                pump();
            });
        },
        { passive: true }
    );

    document.body.addEventListener('htmx:afterSwap', e => scan(e.target ?? document));
    document.body.addEventListener('htmx:afterSettle', e => scan(e.target ?? document));

    const mo = new MutationObserver(mut => {
        for (const m of mut) {
            m.addedNodes.forEach(node => {
                if (node.nodeType !== 1) return;
                if (node.classList?.contains('avatar-holder')) observeWrapper(node);
                scan(node);
            });
        }
    });
    mo.observe(document.body, { childList: true, subtree: true });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
} else {
    init();
}
